const doc = [({"ja":({"adminButtonHotelCancelPolicy":({"deleteCancelPolicy":"ポリシーを削除する", "cancelPolicySetting":"キャンセルポリシー設定", "deleteCancelPolicySetting":"キャンセルポリシー設定を削除する"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;